import { render } from "./GpsStatsTable.vue?vue&type=template&id=5b915bd6&scoped=true"
import script from "./GpsStatsTable.vue?vue&type=script&lang=js"
export * from "./GpsStatsTable.vue?vue&type=script&lang=js"

import "./GpsStatsTable.vue?vue&type=style&index=0&id=5b915bd6&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b915bd6"]])

export default __exports__